import { useEffect, useRef, useState } from "react";
import "./NewsComponent.scss";
import Orders from "../../components/Orders";
import {
  liveRatesApi,
  newsDataApi,
  tagsDataApi,
} from "../../services/ApiService";
import HeroSectionFAQ from "../../components/HeroSectionFAQ";
import ContactUs from "../../components/RequestModal/Form";
import { questionsAnswers } from "../../components/HeroSectionFAQ/base";
import Footer from "../../components/Footer";
import CopyPopup from "./CopyPopup/CopyPopup";
import WhatsappIcon from "../../assets/images/whatsapp_icon.svg";
import LikeIcon from "../../assets/images/likes_filled_icon.svg";
import CustomerLogin from "./CustomerLogin/CustomerLogin";
import chevronRight from "../../assets/images/chevronRight.svg";
import chevronLeft from "../../assets/images/chevronLeft.svg";
import clockIcon from "../../assets/images/Calendar.svg";
import { getTime, canSeeCounts } from "./Utils/utils";
import newsHero from "../../assets/images/default-news-hero.svg";
import { CAN_SEE_COUNTS, ARTICLES_PER_PAGE } from "./constants";

const NewsComponent = () => {
  const formRef = useRef(null);
  const [selectedTag, setSelectedTag] = useState("All");
  const [liveRates, setLiveRates] = useState(null);
  const [originalNews, setOriginalNews] = useState([]);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [categories, setCategories] = useState([
    { id: 0, newsCategoryName: "All" },
  ]);

  const fetchArticles = (page) => {
    newsDataApi({
      limit: ARTICLES_PER_PAGE,
      pageNumber: page,
      category: selectedTag,
    })
      .then((resp) => {
        setOriginalNews(resp?.data?.articles || []);
        setFilteredArticles(resp?.data?.articles || []);
        setTotalPages(Math.ceil((resp?.data?.total || 0) / ARTICLES_PER_PAGE));
      })
      .catch((err) => {
        let msg = "Error occurred while fetching articles.";
        if (typeof err === "string") {
          msg = `Following e${msg.substr(1)}\n${err}`;
        }
        console.error(msg);
      });
  };

  const fetchTags = () => {
    tagsDataApi()
      .then((resp) => {
        setCategories([{ id: 0, newsCategoryName: "All" }, ...resp?.data]);
      })
      .catch((err) => {
        let msg = "Error occurred while fetching the categories.";
        if (typeof err === "string") {
          msg = `Following e${msg.substr(1)}\n${err}`;
        }
        console.error(msg);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchArticles(currentPage);
  }, [currentPage, selectedTag]);

  useEffect(() => {
    fetchTags();
  }, []);

  useEffect(() => {
    liveRatesApi({
      limit: 8,
      pageNumber: 1,
    })
      .then((resp) => {
        setLiveRates(resp?.data);
      })
      .catch((err) => {
        let msg =
          "Error occurred while submitting the request. Please try again.";
        if (typeof err === "string") {
          msg = `Following e${msg.substr(1)}\n${err}`;
        }
        alert(msg);
      });
  }, []);

  const handleTag = (tag) => {
    setSelectedTag(tag);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const getPagination = () => {
    const pages = [];
    const isSmallScreen = window.innerWidth <= 800;

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else if (isSmallScreen) {
      pages.push(1);
      if (currentPage > 2) pages.push("...");
      if (currentPage > 1 && currentPage < totalPages) {
        if (currentPage !== 2) pages.push(currentPage - 1);
        pages.push(currentPage);
        if (currentPage !== totalPages - 1) pages.push(currentPage + 1);
      } else if (currentPage === 1) {
        pages.push(2, 3);
      } else if (currentPage === totalPages) {
        pages.push(totalPages - 2, totalPages - 1);
      }
      if (currentPage < totalPages - 1) pages.push("...");
      pages.push(totalPages);
    } else {
      pages.push(1, 2);
      if (currentPage > 3) pages.push("...");
      const start = Math.max(3, currentPage - 1);
      const end = Math.min(totalPages - 2, currentPage + 1);
      for (let i = start; i <= end; i++) pages.push(i);
      if (currentPage < totalPages - 2) pages.push("...");
      pages.push(totalPages - 1, totalPages);
    }

    return pages;
  };

  const handleLoginModal = (value) => {
    // setIsLoginOpen(value);
  };

  return (
    <>
      <div className="news_container">
        <div className="news_left">
          <h1 className="news_heading">Latest Market News</h1>
          <div className="field requirementForm">
            <div className="news_radio_scroll_container">
              <div
                role="group"
                className="checkbox-group news_checkbox_group"
                aria-labelledby="checkbox-group"
              >
                {categories.map((tag) => (
                  <label key={tag} className="radioButton news_radio_button">
                    <input
                      type="radio"
                      name="fabricCategory"
                      value={tag.newsCategoryName}
                      onClick={() => handleTag(tag.newsCategoryName)}
                      checked={selectedTag === tag.newsCategoryName}
                    />
                    <span>{tag.newsCategoryName}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="news_article_container">
            {filteredArticles?.map((news, index) => (
              <div key={index} className="news_card">
                <div className="news_image_container">
                  <img
                    src={news.newsImageUrl || newsHero}
                    alt={news.newsTitle}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = newsHero;
                    }}
                  />
                </div>
                <div className="news_content_container">
                  <a
                    href={news.newsArticleLink || news.sourceWebsiteUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="news_title_container">
                      <h3>{news.newsTitle}</h3>
                    </div>
                    <div className="news_description_container">
                      {news.newsDescription}
                    </div>
                  </a>
                  <div className="news_links_container">
                    <div className="news_links_left">
                      <div className="news_time_tag_container">
                        <p className="news_time_container">
                          <img
                            src={clockIcon}
                            alt={"created"}
                            className="news_clock_icon"
                          />
                          {getTime(news.createdOn)}
                        </p>
                        <p className="news_tag">{news.categoryName}</p>
                      </div>
                      <div className="news_card_logo_container">
                        <img
                          src={news.sourceImageUrl || newsHero}
                          className="news_publisher_logo"
                          alt={news.sourceName}
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = newsHero;
                          }}
                        />
                        <p className="news_source_title">{news.sourceName}</p>
                      </div>
                    </div>
                    <div className="news_links_right">
                      <div className="news_login_container">
                        <div
                          className="news_icon_container news_whatsapp_icon_container"
                          onClick={handleLoginModal}
                        >
                          <img src={WhatsappIcon} alt="whats" />
                          <p>
                            {canSeeCounts(news.createdOn, CAN_SEE_COUNTS)
                              ? news.initialWhatsappCount
                              : 0}
                          </p>
                        </div>
                        <div
                          className="news_icon_container"
                          onClick={handleLoginModal}
                        >
                          <img src={LikeIcon} alt="like" />
                          <p>
                            {canSeeCounts(news.createdOn, CAN_SEE_COUNTS)
                              ? news.initialLikesCount
                              : 0}
                          </p>
                        </div>
                      </div>
                      <CopyPopup
                        sourceImage={news.newsImageUrl || newsHero}
                        articleHeading={news.newsTitle}
                        sourceLink={
                          news.newsArticleLink || news.sourceWebsiteUrl
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {filteredArticles.length === 0 && (
              <div className="news_no_articles">
                {selectedTag.toLocaleLowerCase() === "all"
                  ? "No articles to display."
                  : `No articles to display in the ${selectedTag} category.`}
              </div>
            )}
            {totalPages > 1 && (
              <div className="news_pagination">
                <button
                  className="news_page_btn"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <img src={chevronLeft} alt="<" />
                </button>

                {getPagination().map((page, i) =>
                  page === "..." ? (
                    <span key={i} className="news_page_btn">
                      ...
                    </span>
                  ) : (
                    <button
                      key={i}
                      className={`news_page_btn ${
                        page === currentPage ? "active" : ""
                      }`}
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  )
                )}

                <button
                  className="news_page_btn"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <img src={chevronRight} alt=">" />
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="news_right">
          <div className="news_right_heading">
            <p>Latest Fabric Prices</p>
          </div>
          <Orders
            liveRates={liveRates}
            isTitleVisible={false}
            GetQutoes={false}
            NewsPage={true}
          />
        </div>
      </div>

      {isLoginOpen && (
        <div className="news_login_modal_overlay">
          <div className="news_modal_content">
            <CustomerLogin handleLoginModal={handleLoginModal} />
          </div>
        </div>
      )}

      <HeroSectionFAQ faqData={questionsAnswers} />
      <ContactUs
        formRef={formRef}
        isButtonShow={false}
        isDirection={true}
        isMember={false}
        isHomePage={true}
      />
      <Footer />
    </>
  );
};

export default NewsComponent;
